import * as R from "ramda";
import React, {Component} from "react";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import Button from "../../../../modules/commons/Button";

class PeriodeFilter extends Component {
    getDataValue(fieldName) {
        return !R.isNil(this.props.state?.searchData) && this.props.state?.searchData[fieldName]
            ? this.props.state?.searchData[fieldName]
            : null;
    }

    componentDidMount() {
        // console.log(this.props.state?.searchData);
    }

    render() {
        return (
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                <div style={{display: "flex", alignItems: "center", gap: "10px"}}>
                    <p className="margin-bottom-20px">{this.props.title || "Periode"}</p>
                    <SimpleDate
                        id={`select_date_${this.props.startDateName}`}
                        name={this.props.startDateName}
                        nextdate
                        date={this.getDataValue(this.props.startDateName)}
                        maxDate={this.getDataValue(this.props.endDateName)}
                        onChange={(value) => this.props.onValueChange(this.props.startDateName, value)}
                    />
                    <span className="margin-bottom-20px">-</span>
                    <SimpleDate
                        id={`select_date_${this.props.endDateName}`}
                        name={this.props.endDateName}
                        nextdate
                        date={this.getDataValue(this.props.endDateName)}
                        onChange={(value) => this.props.onValueChange(this.props.endDateName, value)}
                    />
                    <SimpleButton
                        className="margin-left-none margin-top-5px margin-bottom-20px"
                        onClick={this.props.onSubmit}
                    >
                        Cari
                    </SimpleButton>
                </div>
                {this.props.withFilterButton && (
                    <Button
                        type="button"
                        onClick={this.props.onShowFilter}
                        className="btn background-red margin-bottom-20px"
                    >
            <span>
              <i className="fa fa-qrcode"></i>
            </span>
                    </Button>
                )}
            </div>
        );
    }
}

export default PeriodeFilter;
